var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as SelectionButton from './A_SelectionButton';
import { reorderDimensionsDisplayText } from './utils/reorderDimensionsDisplayText';
export * as Option from './M_SingleSelectList/option';
export var Component = function (p) {
    var sorter = new Intl.Collator('en-GB', { numeric: true }); // TODO: i18n
    var options = p.reorderDimensions
        ? p.options.map(function (option) {
            return __assign(__assign({}, option), { displayName: reorderDimensionsDisplayText(option.displayName) });
        })
        : p.options;
    var sortedOptions = options.sort(function (a, b) { return sorter.compare(a.displayName, b.displayName); });
    var shouldHaveThumbnailOffset = options.some(function (o) { return o.colour || o.image; });
    return (Preact.h(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            padding: '16px',
            gap: '10px',
        } }, sortedOptions.map(function (option) { return (Preact.h(SelectionButton.Component, { text: option.displayName, colour: option.colour, hasThumbnailOffset: shouldHaveThumbnailOffset, image: option.image, selected: option.status === 'active', compatible: option.compatible, onClick: function () { return p.onOptionClick(option.id, option.compatible); } })); })));
};
Component.displayName = 'SingleSelectList';
